import * as React from 'react';
import gettext from '@sdk/lang/gettext';
import Column from '@sdk/components/ui/spacing/Column';
import Text14 from '@sdk/components/ui/typography/Text14';
import TimePicker from '@sdk/components/forms/TimePicker';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import validateTime from 'sling-sdk/src/utils/validation/validateTime';

import CollapsibleSettingsSection from '../CollapsibleSettingsSection';
import RowSpaceBetween from '../RowSpaceBetween';
import SettingsSection from '../SettingsSection';
import SettingsSwitcherRow from '../SettingsSwitcherRow';
import { FIELD_WIDTH_205 } from '../../constants';
import { useSettingsErrorsContext } from '../../SettingsErrorContext';
import { TabType } from '../../types';
import { useUserSettings } from '../../UserSettingsContext';

const DailyEmailReport: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { toggleError, isFieldValid } = useSettingsErrorsContext();
  const { userSettings, onUserSettingsChange } = useUserSettings();
  const { sendDailyReportEmails, dailyReportEmailsDeliveryTime, usTimeFormat } = userSettings;

  return (
    <SettingsSection>
      <CollapsibleSettingsSection
        isActive={sendDailyReportEmails}
        headerItem={
          <SettingsSwitcherRow
            withSeparator
            value={sendDailyReportEmails}
            onChange={(value): void => onUserSettingsChange({ sendDailyReportEmails: value })}
            subtitle={gettext(
              'Receive a daily report via email with information about your employees and hours scheduled.'
            )}
          />
        }
        contentItem={
          <Column pBottom={20}>
            <RowSpaceBetween>
              <Text14 themeColor={ThemeColorType.gray}>
                {gettext('Time of day to deliver email report:')}
              </Text14>
              <TimePicker
                nonEditable
                value={dailyReportEmailsDeliveryTime}
                customWidth={FIELD_WIDTH_205}
                usTimeFormat={usTimeFormat}
                onChange={(value): void => {
                  onUserSettingsChange({ dailyReportEmailsDeliveryTime: value });
                  toggleError(
                    TabType.notifications,
                    'dailyReportEmailsDeliveryTime',
                    !validateTime(value)
                  );
                }}
                invalid={!isFieldValid('dailyReportEmailsDeliveryTime')}
              />
            </RowSpaceBetween>
          </Column>
        }
      />
    </SettingsSection>
  );
};

export default DailyEmailReport;
